
import React, { useEffect, useState } from 'react';
import { SimulationConfig, MelodyName } from './types';
import { SectionLabel } from './SectionLabel';
import { CloudService } from './services/CloudService';
import { ControlGroup } from './ControlGroup';

interface MelodyLibrarySectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const MelodyLibrarySection: React.FC<MelodyLibrarySectionProps> = ({ config, setConfig }) => {
  const [customMelodies, setCustomMelodies] = useState<any[]>([]);

  useEffect(() => {
    CloudService.getMelodies().then(fetched => {
        // Combine fetched melodies with local config.customMelodies
        const allMelodies = [...fetched, ...config.customMelodies];
        // Remove duplicates if any (based on id)
        const uniqueMelodies = Array.from(new Map(allMelodies.map(m => [m.id, m])).values());
        setCustomMelodies(uniqueMelodies);
    });
  }, [config.customMelodies]);

  const melodies: MelodyName[] = [
    'Original Masterpiece',
    'Pentatonic', 'Megalovania', 'Mario', 'Imperial March', 'Tetris', 'Rickroll', 'Pokemon', 'Zelda', 'Nokia', 
    'Fur Elise', 'Canon in D', 'Mortal Kombat', 'Axel F', 'Pirates', 'Star Wars', 'Harry Potter', 'Minecraft', 
    'SpongeBob', 'Under the Sea', 'Circle of Life', 'Smooth Criminal', 'Billie Jean', 'Seven Nation Army', 
    'We Will Rock You', 'Sandstorm', 'Mission Impossible', 'James Bond', 'Nostalgia', 'Gravity Falls', 'Kerosene',
    'Interstellar', 'Inception', 'Stranger Things', 'Cyberpunk', 'Get Lucky', 'Blinding Lights', 'Take On Me',
    'Final Fantasy', 'Doom', 'Pac-Man', 'Sonic', 'Skyrim', 'Bad Apple', 'Rush E', 'Giorno',
    'One Summers Day', 'Merry-Go-Round', 'Unravel', 'Cruel Angel', 'Tokyo Ghoul',
    'Custom (Uploaded)'
  ];

  return (
    <div className="flex flex-col gap-3 p-4 rounded-3xl border bg-purple-500/5 border-purple-500/20">
      <SectionLabel icon="fa-guitar" darkMode={config.darkMode}>Melody Library</SectionLabel>
      <ControlGroup label="Select Melody" settingKey="selectedMelody" darkMode={config.darkMode}>
        <select 
          value={config.selectedMelody} 
          onChange={e => setConfig(p => ({ ...p, selectedMelody: e.target.value as MelodyName }))} 
          className={`w-full px-3 py-2 border rounded-xl text-[10px] font-black ${config.darkMode ? 'bg-neutral-800 border-neutral-700' : 'bg-white border-neutral-200'}`}
        >
          <optgroup label="Core Melodies">
              {melodies.map(m => <option key={m} value={m}>{m}</option>)}
          </optgroup>
          {customMelodies.length > 0 && (
              <optgroup label="User Created">
                  {customMelodies.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </optgroup>
          )}
        </select>
      </ControlGroup>
    </div>
  );
};
